<template lang="pug">
    d2-container
            el-form(:inline='true', :model='form', size='mini',label-width="75px",  @keyup.enter.native='getDataList()')
              el-row
                el-col(:span='5')
                  el-form-item(label="姓名:" label-width="72px")
                      el-input(v-model='form.userName', placeholder='姓名', clearable='',style="width:170px;")
                el-col(:span='8')
                  el-form-item(label="地区:" label-width="72px" )
                    el-row(style='width:360px')
                      el-col(style="width:120px;")
                        el-select(v-model="form.provice" placeholder="请选择" @change="changeProvice"  clearable)
                          el-option(v-for="(item,index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
                      el-col(style="width:30px;" class="line") &nbsp;&nbsp;省&nbsp;&nbsp;
                      el-col(style="width:120px;")
                        el-select(v-model="form.city" placeholder="请选择" clearable)
                          el-option(v-for="(item,index) in cityList" :key="index" :label="item.cityname" :value="item.cityId")
                      el-col(style="width:30px;") &nbsp;&nbsp;市&nbsp;
                el-col(:span='5')
                  el-form-item(label="主办方:" label-width="72px")
                    el-select(v-model="form.orgId" placeholder="请选择" filterable clearable style="width:170px;")
                      el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
              el-row
                el-col(:span='5')
                  el-form-item(label="业务类别:" label-width="72px" )
                    el-select(v-model="form.busCategory" placeholder="请选择" clearable style="width:170px;")
                      el-option(label="分级公开赛" :value="1")
                      el-option(label="俱乐部公开赛" :value="2")
                      el-option(label="分级单次培训" :value="3")
                      el-option(label="分级整期培训" :value="4")
                      el-option(label="青少年儿童培训" :value="5")
                      el-option(label="个人定制化培训" :value="6")
                el-col(:span='8')
                  el-form-item(label='业务状态' label-width="72px" )
                    el-select.inputWidth(v-model='form.busStatus',placeholder='请选择业务状态',clearable)
                      el-option(v-for="e in busStatusArr" :label='e.label', :value="e.value")
                el-col(:span='10')
                  el-form-item(label='缴纳日期:' label-width="72px")
                    el-date-picker(style='width:310px', v-model='form.payDate' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
              el-row(style="padding-bottom:15px;")
               el-col(:span="24")
                  el-button(v-if="isAuth('operation:place:save')", type='primary', @click='exportExcel()') 导出报表
                  el-button(style="float:right;" type='primary',icon='el-icon-search', @click='getDataList()' ) 查询
            el-table(:data='dataList', border, v-loading='dataListLoading', style='width: 100%;')

                el-table-column(prop='userName', header-align='center', align='center', label='姓名')
                el-table-column(prop='busCategory', header-align='center', align='center', label='业务类别')
                    template(slot-scope="scope")
                      span(v-if='scope.row.busCategory==-1') 青少年公开赛
                      span(v-if='scope.row.busCategory==1') 分级公开赛
                      span(v-if='scope.row.busCategory==2') 俱乐部公开赛
                      span(v-if='scope.row.busCategory==3') 分级单次培训
                      span(v-if='scope.row.busCategory==4') 分级整期培训
                      span(v-if='scope.row.busCategory==5') 青少年儿童培训
                      span(v-if='scope.row.busCategory==6') 个人定制化培训
                el-table-column(prop='orgName', header-align='center', align='center', label='主办方')
                el-table-column(prop='busName', header-align='center', align='center', label='业务名称')
                el-table-column(prop='busCode', header-align='center', align='center', label='业务ID')
                el-table-column(prop='busStatus', header-align='center', align='center', label='业务状态')
                    template(slot-scope="scope")
                      span(v-if='scope.row.busStatus==1') 未审核
                      span(v-if='scope.row.busStatus==2') 已发布
                      span(v-if='scope.row.busStatus==3') 已取消
                      span(v-if='scope.row.busStatus==4') 已结束
                el-table-column(prop='payTime', header-align='center', align='center', label='缴纳时间')
                el-table-column(prop='type', header-align='center', align='center', label='缴费类型')
                    template(slot-scope="scope")
                      span(v-if='scope.row.type==1') 预缴费
                      span(v-if='scope.row.type==2') 统一结算
                el-table-column(prop='shallAmount', header-align='center', align='center', label='预付金额')
                    template(slot-scope="scope")
                      font(v-if='scope.row.shallAmount != null && scope.row.type==1')
                        span() ¥ {{parseFloat(scope.row.shallAmount).toFixed(2)}} 元
                el-table-column(prop='payAmount', header-align='center', align='center', label='实付金额/结算金额')
                    template(slot-scope="scope")
                      font(v-if='scope.row.payAmount != null')
                        span() ¥ {{parseFloat(scope.row.payAmount).toFixed(2)}} 元
                el-table-column(prop='status', header-align='center', align='center', label='缴费状态')
                    template(slot-scope="scope")
                      font(v-if='scope.row.status==0')
                        span.danger()
                        span() &nbsp; 未缴费
                      font(v-if='scope.row.type==1 && scope.row.status==1')
                        span.success()
                        span() &nbsp; 已缴费
                      font(v-if='scope.row.type==1 && scope.row.status==2')
                        span.warning()
                        span() &nbsp; 已退费
                      font(v-if='scope.row.type==1 && scope.row.status==3')
                        span.warning()
                        span() &nbsp; 多余钱款已退
                      font(v-if='scope.row.status!=0 && scope.row.type==2') 线下支付
                el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('operation:place:info')" :disabled='scope.row.status!=1 || scope.row.busStatus!=4'  @click="toRefund(scope.row)") 退款

            el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
</template>
<script>
import table from './table.js'
export default {
  name: 'place',
  data () {
    return {
       table: {
          columns: table.columns,
          data: null,
          size: 'mini',
          stripe: true,
          border: true
      },
      isCollapse: true,
      form: {
        userName: '',
        proviceName: '',
        cityName: '',
        orgName: '',
        provice: '',
        city: '',
        orgId: '',
        busCategory: '',
        busStatus: '',
        payDate: ''
      },
      proviceList: [],
      cityList: [],
      sysOrgList: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      viewVisible: false,
      busStatusArr: [
        { value: 1, label: '未审核' },
        { value: 2, label: '已发布' },
        { value: 3, label: '已取消' },
        { value: 4, label: '已结束' }
      ]

    }
  },

  created () {
    this.getDataList()
    this.initProvice()
    this.changeOrg()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let payTimeStr = null
      let payTimeEnd = null
      if (this.form.payDate !== null) {
        if (this.form.payDate.length > 0) {
          payTimeStr = this.form.payDate[0]
          payTimeEnd = this.form.payDate[1]
        }
      }
      console.log('form:', this.form)
      this.$http({
        url: this.$http.adornUrl('/frFranchiseFeeRecord/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          userName: this.form.userName,
          payTimeStr: payTimeStr,
          payTimeEnd: payTimeEnd,
          provice: this.form.provice,
          city: this.form.city,
          orgId: this.form.orgId,
          busCategory: this.form.busCategory,
          busStatus: this.form.busStatus
        }
      }).then(data => {
        if (data && data.code === 0) {
          console.log('data', data)
          this.dataList = data.page.rows
          this.totalPage = data.page.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    handleClose () {},
    handleOpen () {},
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(id)
      })
    },
    initProvice () {
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(data => {
        this.proviceList = data && data.code === 0 ? data.list : []
        this.changeOrg()
      })
    },
    changeProvice () {
      this.cityList = []
      this.form.cityId = ''
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: this.$http.adornParams({
          proviceId: this.form.provice
        })
      }).then(data => {
        this.cityList = data && data.code === 0 ? data.list : []
        this.changeOrg()
      })
    },
    changeOrg () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams({
          cityId: this.form.city,
          proviceId: this.form.provice
        })
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    toRefund (row) {
      //退款
      this.$http({
        url: this.$http.adornUrl('/frFranchiseFeeRecord/franchiseRefund'),
        method: 'post',
        data: row
      }).then(data => {
        if (data && data.code === 0) {
          console.log('data', data)
          this.$message.info(data.msg || '退款成功!')
        } else {
          this.$message.info(data.msg || '退款失败!')
        }
      }).catch(e => {
        this.$message.info(e.msg || '退款失败!')
      })
    },
    exportExcel () {
      //导出列表
      let payTimeStr = null
      let payTimeEnd = null
      if (this.form.payDate !== null) {
        if (this.form.payDate.length > 0) {
          payTimeStr = this.form.payDate[0]
          payTimeEnd = this.form.payDate[1]
        }
      }
      this.$http({
        url: this.$http.adornUrl('/frFranchiseFeeRecord/exportList'),
        method: 'POST',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          userName: this.form.userName,
          payTimeStr: payTimeStr,
          payTimeEnd: payTimeEnd,
          provice: this.form.provice,
          city: this.form.city,
          orgId: this.form.orgId,
          busCategory: this.form.busCategory,
          busStatus: this.form.busStatus
        }
      }).then(data => {
        console.log(data)
        if (data && data.code === 0) {
            console.log(data.list)
            if (data.list == null || data.list.length === 0) {
                this.$message.info('没有要导出的数据!')
                return
            }
            let exportData = data.list
            for (let i of exportData) {
                i.payAmount = i.payAmount ? '¥' + parseFloat(i.payAmount).toFixed(2) + '元' : ''
                i.shallAmount = i.shallAmount ? '¥' + parseFloat(i.shallAmount).toFixed(2) + '元' : ''
                i.type = { 1: '预缴费', 2: '统一结算' }[i.type]
                i.status = { 0: '未缴费', 1: '已缴费', 2: '已退费', 3: '多余钱款已退' }[i.status]
                i.busStatus = { 1: '未审核', 2: '已发布', 3: '已取消', 4: '已结束' }[i.busStatus]
                i.busType = { 1: '比赛', 2: '培训' }[i.busType]
                i.busCategory = { 1: '分级公开赛', 2: '俱乐部公开赛', 3: '分级单次培训', 4: '分级整期培训', 5: '青少年儿童培训', 6: '个人定制化培训' }[i.busCategory]
            }
            console.log('导出的订单数据：', exportData)
            this.$export.excel({
                columns: this.table.columns,
                data: exportData,
                title: '加盟费费用表单'
            }).then(() => {
                this.$message.success('导出表格成功')
            })
        }
      })
    }
  }
}
</script>
<style>
  /* 操作三点 菜单样式 */
 @import '../../../css/opr3dot.css';
</style>>
